import * as browserHelper from './client/browserHelper';
import { lWindow } from './common/helpers';

const reportError = (err, extras = {}) => {
  if (typeof lWindow !== 'undefined' && browserHelper.hasRaven(lWindow)) {
    lWindow.Raven.captureException(err, extras);
  }
};

export default reportError;